module.exports = __webpack_public_path__ + "img/call-image.b106cfc8.jpg";